module.exports = __webpack_public_path__ + "static/img/ljqs.fb0d6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/ljqs.png
// module id = c1Oa
// module chunks = 0